import { Box, Typography } from "@mui/material";

import { color } from "../theme/designTokens";

type InfoFieldProps = {
  label: string;
  value: string | undefined | null;
};

export const InfoField = ({ label, value }: InfoFieldProps) => {
  return (
    <Box sx={{ minWidth: 0, maxWidth: "100%", overflowWrap: "anywhere" }}>
      <Typography variant="caption" color={color.gray}>
        {label}
      </Typography>
      <Typography variant="subtitle1" fontWeight="medium">
        {value ?? "-"}
      </Typography>
    </Box>
  );
};
